<template>
  <div
    class="status-chip"
    :class="{
      successStatus: status === 'success',
      activeStatus: status === 'active',
      errorStatus: status === 'error',
      fixedWidth,
      rightPadding,
    }"
  >
    <v-icon
      v-if="loading"
      small
      class="loading-spinner mr-2"
      :color="loadingColor"
      >mdi-cached</v-icon
    >{{ text }}
  </div>
</template>
<script>
export default {
  props: {
    loading: { type: Boolean, default: false },
    text: { type: String, default: null },
    status: { type: String, default: null },
    fixedWidth: { type: Boolean, default: false },
    rightPadding: { type: Boolean, default: false },
  },
  computed: {
    loadingColor() {
      switch (this.status) {
        case 'success':
          return '#44aa99'
        case 'active':
          return '#2196f3'
        case 'error':
          return '#ff5252'
        default:
          return '#ffffff'
      }
    },
  },
}
</script>
<style scoped>
.status-chip {
  padding: 4px 30px;
  font-weight: 650;
  border-radius: 15px;
  text-align: center;
  font-size: 14px;
}

.status-chip.fixedWidth {
  min-width: 155px;
}

.status-chip.rightPadding {
  margin-right: 8px;
}

.status-chip.successStatus {
  color: #359585;
  background: #e5fae1;
}

.status-chip.activeStatus {
  color: #2196f3;
  background: #e4f3ff;
}

.status-chip.errorStatus {
  color: #ff5252;
  background: #ffecec;
}

.loading-spinner {
  animation: loader 1s infinite linear;
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
